import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './components/LoginPage';
import VideosManager from './components/VideosManager';
import ComingSoon from './components/ComingSoon';

function AdminApp() {
  const { user } = useAuth();
  return user ? <VideosManager /> : <LoginPage />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/"       element={<ComingSoon />} />
          <Route path="/admin"  element={<AdminApp />} />
          <Route path="/admin/*" element={<AdminApp />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}